import {RouteConfig} from 'vue-router'
import Layout from '@/layout/index.vue'

const equipRouter: RouteConfig = {
  path: '/equipManage',
  redirect: 'noredirect',
  name: 'equipManage',
  component: Layout,
  children: [
    {
      path: 'equipManage',
      component: () => import('@/views/equipManage/index.vue'),
      name: 'Apparatus',
      meta: {
        title: '器材管理',
        icon: 'resource',
        requireAuth: true
      }
    },
  ]

}

export default equipRouter
